import React from 'react';
import { Container, Typography, Box, Grid2 as Grid, Divider } from '@mui/material';
import Footer from "../layout/Footer";

const TerminosCondiciones = () => {
  return (
    <>
      {/* Hero Section */}
      <Box className="header-container">
        <Container maxWidth="lg" sx={{ py: 4 }}>
          <Grid container size={12} sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="h1" component="h1" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>
              Términos y Condiciones de Uso
            </Typography>
            <Typography variant="h3" component="h3" gutterBottom sx={{ color: 'white', textAlign: 'center' }}>
              One Service Inversiones<br />
              Fecha de última actualización: 23 Julio 2025
            </Typography>
          </Grid>
        </Container>
      </Box >

      <Container maxWidth="md" sx={{ py: 6 }}>

        <Typography variant="body1" paragraph sx={{ mt: 2 }}>
          El uso de la plataforma One Service Inversiones (en adelante, la “Plataforma”) implica la aceptación plena y sin reservas de los presentes Términos y Condiciones. Si no estás de acuerdo con ellos, por favor abstente de utilizar el sitio y sus funcionalidades.
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            1. Definiciones
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>One Service Inversiones:</strong> Plataforma digital de fondeo colectivo orientada a financiar el crecimiento de una red de prestadores de servicios locales.<br />
            <strong>Usuario:</strong> Persona física que navega, consulta, se registra o realiza aportaciones dentro de la Plataforma.<br />
            <strong>Aportaciones:</strong> Transferencias voluntarias de dinero realizadas por los usuarios con el objetivo de apoyar el crecimiento de la red de prestadores de servicios.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            2. Uso de la Plataforma
          </Typography>
          <Typography variant="body1" paragraph>
            · El Usuario declara tener al menos 18 años y contar con capacidad legal para utilizar la Plataforma y realizar aportaciones voluntarias.<br />
            · One Service Inversiones ofrece herramientas digitales para facilitar la vinculación entre el capital de los usuarios y la expansión de actividades económicas locales.<br />
            · Los fondos recaudados se destinan al crecimiento operativo, capacitación, equipamiento o incorporación de nuevos prestadores de servicios locales.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            3. Naturaleza de la Participación
          </Typography>
          <Typography variant="body1" paragraph>
            · Las aportaciones realizadas por el Usuario no representan acciones, deuda, instrumentos financieros ni derechos patrimoniales formales sobre One Service o sobre los prestadores de servicios.<br />
            · El Usuario entiende que esta es una iniciativa de impacto económico local, basada en la confianza, la trazabilidad de los recursos y la transparencia operativa.<br />
            · La participación no otorga derechos de gestión ni decisiones sobre la empresa.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            4. Rendimientos
          </Typography>
          <Typography variant="body1" paragraph>
            · Algunas aportaciones podrán dar lugar al pago de rendimientos, los cuales estarán sujetos a condiciones específicas establecidas en cada campaña o convocatoria publicada.<br />
            · Los rendimientos no están garantizados y dependerán del desempeño operativo y financiero del modelo de negocio impulsado con las aportaciones.<br />
            · Cualquier pago de rendimientos se realizará mediante transferencia electrónica a la cuenta registrada por el Usuario, en los plazos que se indiquen en la documentación correspondiente.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            5. Transparencia y Seguimiento
          </Typography>
          <Typography variant="body1" paragraph>
            · One Service Inversiones podrá emitir reportes periódicos sobre el uso de los recursos, avances del proyecto y resultados operativos obtenidos.<br />
            · El Usuario podrá consultar esta información mediante la Plataforma o solicitarla por correo: atencion@oneservice.com.mx.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            6. Propiedad Intelectual
          </Typography>
          <Typography variant="body1" paragraph>
            Todo el contenido (marca, logotipo, diseño, textos, gráficos y estructura) pertenece a One Service. Se prohíbe su reproducción sin autorización expresa.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            7. Seguridad y Datos Personales
          </Typography>
          <Typography variant="body1" paragraph>
            One Service se compromete a proteger la información personal conforme a la legislación vigente y lo dispuesto en el Aviso de Privacidad.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            8. Limitación de Responsabilidad
          </Typography>
          <Typography variant="body1" paragraph>
            · One Service Inversiones no garantiza beneficios económicos.<br />
            · El uso de la Plataforma es bajo responsabilidad exclusiva del Usuario.<br />
            · No existe compromiso de reembolso automático o cobertura en caso de pérdida total o parcial del capital aportado.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            9. Cambios en los Términos
          </Typography>
          <Typography variant="body1" paragraph>
            Estos Términos podrán modificarse sin previo aviso. La versión vigente será publicada en el sitio web.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 'medium', color: '#2E7D32' }}>
            10. Jurisdicción
          </Typography>
          <Typography variant="body1" paragraph>
            Para la interpretación de estos Términos se aplicarán las leyes de los Estados Unidos Mexicanos. Toda controversia será resuelta en los tribunales de la Ciudad de México.
          </Typography>
        </Box>
      </Container>
      <Footer />
    </>
  );
};

export default TerminosCondiciones;